module.exports = __webpack_public_path__ + "static/media/project.ec579a3a.png";